// @flow
import React from 'react';
import cx from 'classnames';

import Letterpone from '../Letterpone/Letterpone';
import GrayBox from '../GrayBox';
import GrayBoxes from '../GrayBoxes';

type Props = {
  oneColumn?: boolean,
};

const FakeLetterCard = ({ oneColumn }: Props) => (
  <Letterpone duration={100}>
    <div className={cx('LetterCard FakeLetterCard', { 'one-column': oneColumn })}>
      <div className="card-content">
        <div className="content-head">
          <h3 className="title">
            <GrayBox min={2} max={2} />
            <GrayBox min={2.5} max={2.5} />
            <GrayBox min={2.5} max={2.5} />
            <GrayBox min={2.5} max={2.5} />
            <GrayBox min={3} max={3} />
          </h3>
          <div className="description">
            <GrayBoxes countMin={8} countMax={8} sizeMin={2.5} sizeMax={3.5} />
          </div>
        </div>
      </div>
    </div>
  </Letterpone>
);

FakeLetterCard.defaultProps = {
  oneColumn: false,
};

export default FakeLetterCard;



// WEBPACK FOOTER //
// ./src/components/common/FakeLetterCard/FakeLetterCard.js